const endpoints = {
    otpSend: 'admin-utilities/otp/send',
    otpVerify : 'admin-utilities/otp/verify',
    adminList : 'admins/',
    MDList: 'admins/',
    bankList : 'banks/',
    regionalOfficeList : 'regional-offices',
    masterDistributorsList : 'master-distributors/',
    distributorsList : 'distributors/',
    subDistributorsList : 'sub-distributors/',
    agentsList : 'agents/',
    mnoList: 'mnos/',
    manualEntries: 'manual-entries/',
    pendingAmount: 'pending-amount-transactions/',
    raiseETopUpRequest: 'cash-in',
    raiseETopUpRequestPaid: 'cash-in/paid',
    regionalOffices : 'regional-offices',
    target: 'mnos/targets/',
  };
  
  export default endpoints;
  